import React, { useEffect, useState, useRef } from "react";

import {
  SearchOutlined,
  EditOutlined,
  ReloadOutlined,
  CheckOutlined,
  DownOutlined,
} from "@ant-design/icons";
import {
  PageHeader,
  Pagination,
  Input,
  Button,
  Table,
  Spin,
  Typography,
  Tag,
  List,
  InputNumber,
  Tabs,
  message,
  Space,
  Dropdown,
  DatePicker,
} from "antd";

import moment from "moment";
import PurchaseTable from "../../components/purchasing/Table";
import PurchasingJustRetrunthetotal from "../../components/purchasing/PurchasingJustRetrunthetotal";

import AddEditModal from "../../components/Generic/AddEditModal";
import ImageChecker from "../../components/Generic/ImageChecker";
import { numberWithCommas } from "../../utils/helpers";
import { getLocations } from "../../Redux/actions/locationsActions";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {
  loadMorePurchaseData,
  approvePurchase,
  completePurchase,
  getCurrentItemPrice,
  backtoapprovePurchase,
} from "../../Redux/actions/purchaseActions";
import "./styles.scss";
import "./styles.css";

import PrintPackageLabel from "../../components/packages/PrintPackageLabel";
import ShipPackage from "../../components/packages/ShipPackage";
import PrintPurchaseOrderList from "../../components/purchasing/PrintPurchaseOrderList";

import PurchasingAddEdit from "../../components/purchasing/PurchasingAddEdit";

const { RangePicker } = DatePicker;
const { TabPane } = Tabs;
const { Search } = Input;
const INITIAL_STATE = {
  searchText: "",
};
const API_URL = "purchaseorders";

const PAGENAME = "Purchase Request";

const MODAL_BLUEPRINT = [
  {
    title: "Name",
    key: "name",
    type: "text",
  },
  {
    title: "Address",
    key: "address",
    type: "text",
  },
  {
    title: "phone",
    key: "contactno",
    type: "number",
  },
  {
    title: "contact person",
    key: "contact_person",
    type: "text",
  },
  {
    title: "operating hours",
    key: "operating_hours",
    type: "text",
  },
];

const Index = (props) => {
  const [loading, setloading] = useState(false);
  const [mainSearch, setMainSearch] = useState(null);
  const [resetTable, setResetTable] = useState(false);

  const [modalMode, setModalMode] = useState("edit");
  const [currentSelected, setCurrentSelected] = useState(null);
  const [currentSelectedRow, setCurrentSelectedRow] = useState(null);

  const [packageStatus, setPackageStatus] = useState("toApprove");

  const [Rtotal, setRTotal] = useState(0);

  const [currentPrice, setItemCurentPrices] = useState({});

  const [somethingChanged, setSomethingChanged] = useState(false);

  const [locationMenu, setLocationMenu] = useState([]);
  const [selectedDestination, setSelectedDestination] = useState("all");

  const [datePickerValue, setDatePickerValue] = useState([
    moment().startOf("date").subtract(60, "days"),
    moment().endOf("date"),
  ]);
  const [datePickerValueTemp, setDatePickerValueTemp] = useState([
    moment().startOf("date").subtract(60, "days"),
    moment().endOf("date"),
  ]);

  const tableRef = useRef();
  const dispatch = useDispatch();
  const { crudData, crudDataCount, locations, user } = useSelector(
    (state) => ({
      user: state.auth.user,
      crudData: state.purchases.data,
      crudDataCount: state.purchases.dataCount,
      locations: state.locations.locations,
    }),
    shallowEqual
  );
  useEffect(() => {
    dispatch(getLocations());
  }, []);

  useEffect(() => {
    compputeTotal();
    if (crudData.length > 100) {
      var newdatevalue = datePickerValue;
      var created_at = crudData[crudData.length - 1].created_at;
      newdatevalue[0] = moment(created_at, "YYYY-MM-DD HH:mm:ss");
      setDatePickerValueTemp(newdatevalue);
    }
  }, [crudData]);

  useEffect(() => {
    const destinationOptions = [
      {
        label: "All",
        key: "all",
      },
    ];
    locations.forEach((element) => {
      destinationOptions.push({
        label: element.name,
        key: element.key,
      });
    });
    console.log("destinationOptions", destinationOptions);
    setLocationMenu(destinationOptions);
  }, [locations]);

  useEffect(() => {
    compputeTotal();
  }, [selectedDestination]);

  const compputeTotal = async () => {
    var reqeusts_total = 0;
    var newcurrentprice = {
      ...currentPrice,
    };
    let dataArray = crudData;
    if (selectedDestination !== "all") {
      dataArray = crudData.filter((order) =>
        selectedDestination
          ? order.package_list?.some(
              (p) => p.destination === selectedDestination
            )
          : true
      );
    }
    await Promise.all(
      dataArray.map(async (requests) => {
        await Promise.all(
          requests.items.map(async (it) => {
            var usethiscost = it.cost_peso_new;
            if (requests.status == "toApprove") {
              usethiscost = await returncurrentprice(it.id);
              if (usethiscost) {
                newcurrentprice = {
                  ...newcurrentprice,
                  [`${it.id}`]: usethiscost,
                };
              }
            }

            reqeusts_total =
              reqeusts_total + parseFloat(usethiscost) * parseFloat(it.tobuy);
          })
        );
        // console.log(reqeusts_total)
      })
    );
    setItemCurentPrices(newcurrentprice);
    setRTotal(reqeusts_total);
  };

  const returncurrentprice = async (prod) => {
    var cprice = await dispatch(getCurrentItemPrice(prod));

    return cprice;
  };

  const onSearch = (value) => {
    setMainSearch(value);
  };

  const itemSelected = (value) => {
    console.log(value);

    setCurrentSelected(value);
  };

  const rowIsSelected = (value) => {
    console.log(value);

    setCurrentSelectedRow(value);
  };

  const actionsRender = (record) => {
    const approve = () => {
      var newitems = record.items.map((it) => {
        var newit = {
          ...it,
          cost_peso_new: parseFloat(currentPrice[it.id]).toFixed(2),
        };
        return newit;
      });

      setloading(true);
      dispatch(approvePurchase(record.id, newitems))
        .then((res) => {
          setResetTable(!resetTable);
          message.success(`${record.id} - approved`);
          setloading(false);
        })
        .catch((err) => {
          setResetTable(!resetTable);
          setloading(false);
        });
    };

    const complete = () => {
      setloading(true);
      dispatch(completePurchase(record))
        .then((res) => {
          setResetTable(!resetTable);
          message.success(`${record.id} - completed`);
          setloading(false);
        })
        .catch((err) => {
          setResetTable(!resetTable);
          setloading(false);
        });
    };

    const backtoApproved = () => {
      setloading(true);
      dispatch(backtoapprovePurchase(record.id))
        .then((res) => {
          setResetTable(!resetTable);
          message.success(`${record.id} - set back To Approved`);
          setloading(false);
        })
        .catch((err) => {
          setResetTable(!resetTable);
          setloading(false);
        });
    };

    const allhaspriceChecker = () => {
      var ok = true;
      record.items.map((it) => {
        if (
          !it.cost_peso_new ||
          it.cost_peso_new == 0 ||
          !it.cost_peso ||
          it.cost_peso == 0
        ) {
          message.error(`${it.name} has no price`);
          ok = false;
        }
      });
      if (ok) {
        if (record.status == "toApprove") {
          approve();
        } else {
          complete();
        }
      }
    };

    if (record) {
      var newrec = {
        ...record,
      };
      var dest = locations.filter((i) => i.id == record.destination);
      var destData = dest[0];
      if (destData) {
        newrec["dest"] = destData;
      }
      return (
        <div>
          {user.role == "admin" && record.status == "toApprove" ? (
            <Button
              type="primary"
              loading={loading}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                allhaspriceChecker();
              }}
            >
              Approve
            </Button>
          ) : null}

          {record.status == "approved" ? (
            <Button
              type="primary"
              loading={loading}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                allhaspriceChecker();
              }}
            >
              Complete
            </Button>
          ) : null}
          {record.status == "approved" ? (
            <Button
              type="dashed"
              loading={loading}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                backtoApproved();
              }}
            >
              Back To Approve
            </Button>
          ) : null}
          <PrintPurchaseOrderList currentItem={record} />
        </div>
      );
    }
  };

  var columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id.localeCompare(b.id),

      render: (text, record, index) => {
        return (
          <div className="vertical">
            <span> {text} </span>
            <div> {actionsRender(record)}</div>
          </div>
        );
      },
    },

    {
      title: "Created For",
      dataIndex: "created_for",
      key: "created_for",
      sorter: (a, b) => a.created_for.localeCompare(b.created_for),
      render: (text, record, index) => {
        return (
          <div className="vertical">
            <span> {moment(text).format("LLL")} </span>
            <span> by: {record.created_by_name}</span>
          </div>
        );
      },
    },
    {
      title: "Packages",
      render: (text, record, index) => {
        return (
          <div className="vertical">
            {record.package_list.map((pk) => {
              return (
                <span>
                  <h4>{pk.destination_name}</h4> <span>- {pk.id}</span>{" "}
                </span>
              );
            })}
          </div>
        );
      },
    },
  ];

  const filterCols = () => {
    var newcols = columns;
    var total = [
      {
        title: "Total",
        dataIndex: "costTotal",
        key: "costTotal",

        render: (text, record, index) => {
          return <PurchasingJustRetrunthetotal purchaseItem={record} />;
        },
      },
    ];
    if (user.role == "admin" || user.role == "warehouse") {
      newcols = newcols.concat(total);
    }

    var itemslist = [
      {
        title: "Items",
        render: (text, record, index) => {
          return (
            <List
              className="Itemlist"
              itemLayout="horizontal"
              dataSource={record.items}
              size={"small"}
              renderItem={(item) => (
                <List.Item
                // actions={[
                //   <Button type='link' onClick={()=>{deleteThis(item.id)}}>
                //     <DeleteOutlined  />
                //   </Button>
                // ]}
                >
                  <List.Item.Meta
                    avatar={
                      <ImageChecker
                        url={`${process.env.REACT_APP_AWS_S3}${item.product}.png`}
                        success={
                          <img
                            src={`${process.env.REACT_APP_AWS_S3}${item.product}.png`}
                            alt="image"
                            className={"prodimage"}
                          />
                        }
                        fail={
                          <img
                            src={`${process.env.REACT_APP_AWS_S3}logo.jpg`}
                            alt="image"
                            className={"prodimage"}
                          />
                        }
                      />
                    }
                    title={<span className="name">{item.product_name}</span>}
                    description={
                      <div className="verticalItem">
                        <div>{` x ${item.quantity}   ${
                          item.tobuy ? ` actual: ${item.tobuy}` : ``
                        } `}</div>
                        {user.role == "admin" || user.role == "warehouse" ? (
                          record.status == "toApprove" ? (
                            <div>
                              {" "}
                              ₱
                              {numberWithCommas(
                                parseFloat(currentPrice[item.id]).toFixed(2)
                              )}
                            </div>
                          ) : (
                            <div>
                              {" "}
                              ₱
                              {numberWithCommas(
                                parseFloat(item.cost_peso_new).toFixed(2)
                              )}
                            </div>
                          )
                        ) : null}
                      </div>
                    }
                  />
                  {user.role == "admin" || user.role == "warehouse" ? (
                    record.status == "toApprove" ? (
                      <div>
                        {" "}
                        ₱
                        {numberWithCommas(
                          parseFloat(
                            parseFloat(currentPrice[item.id]) * item.tobuy
                          ).toFixed(2)
                        )}
                      </div>
                    ) : (
                      <div>
                        {" "}
                        ₱
                        {numberWithCommas(
                          parseFloat(item.cost_peso_new * item.tobuy).toFixed(2)
                        )}
                      </div>
                    )
                  ) : null}
                </List.Item>
              )}
            />
          );
        },
      },
    ];

    newcols = newcols.concat(itemslist);
    return newcols;
  };

  return (
    <div className="maindiv">
      <div className={"generic_container"}>
        <PageHeader
          title={PAGENAME + "s"}
          subTitle={
            <div className={"header"}>
              {/* <Search placeholder="input search text" allowClear={true} onChange={(e)=>{if(!e.target.value &&mainSearch){onSearch(null)}}} onSearch={onSearch} enterButton />  */}
            </div>
          }
          extra={
            <div className={"header"}>
              {/* <PackageModal currentItem={currentSelectedRow} 
                        onCancelmodal ={()=>{   
                          setCurrentSelectedRow(false);                    
                          setCurrentSelected(null)}
                        }
                        onCloseModal={(e)=>{
                          setCurrentSelectedRow(false);
                          setResetTable(!resetTable)
                          setCurrentSelected(null)
                        }}/> */}

              <RangePicker
                style={{ marginRight: "2em", minWidth: "18em" }}
                value={datePickerValueTemp}
                onChange={(e) => {
                  if (e && e[0] && e[1]) {
                    setDatePickerValueTemp(e);
                  }
                }}
                renderExtraFooter={() => (
                  <Button
                    onClick={() => {
                      setDatePickerValue(datePickerValueTemp);
                    }}
                  >
                    Set
                  </Button>
                )}
              />
              {user.role == "admin" || user.role == "warehouse" ? (
                <Dropdown.Button
                  menu={{
                    items: locationMenu,
                    onClick: (e) => setSelectedDestination(e.key),
                    selectable: true,
                    selectedKeys: [selectedDestination],
                  }}
                  style={{ marginRight: "2em" }}
                >
                  <Space>Locations</Space>
                </Dropdown.Button>
              ) : null}
              {user.role == "admin" || user.role == "warehouse" ? (
                <h2 style={{ marginRight: "1em" }}>
                  Total: ₱ {Rtotal ? numberWithCommas(Rtotal.toFixed(2)) : 0}
                </h2>
              ) : null}
              <PurchasingAddEdit
                purchaseItem={currentSelectedRow}
                mode="edit"
                onCloseModal={(e) => {
                  compputeTotal();
                  setCurrentSelectedRow(null);
                  setResetTable(!resetTable);
                }}
                onCancelmodal={(e) => {
                  compputeTotal();
                  setCurrentSelectedRow(null);
                  if (somethingChanged) {
                    setResetTable(!resetTable);
                    setSomethingChanged(false);
                  }
                }}
                somethingchanged={() => {
                  setSomethingChanged(true);
                }}
              />

              {crudDataCount > 0 ? (
                <Button
                  type={"primary"}
                  shape={"round"}
                  onClick={() => {
                    dispatch(loadMorePurchaseData());
                  }}
                  style={{ marginRight: "1em" }}
                >
                  Load More
                </Button>
              ) : null}

              <Button
                onClick={() => {
                  setResetTable(!resetTable);
                }}
                className="button"
              >
                <ReloadOutlined />
              </Button>
            </div>
          }
        >
          <Tabs
            defaultActiveKey="To Approve"
            onChange={(e) => {
              setPackageStatus(e);
            }}
          >
            <TabPane tab="To Approve" key={"toApprove"} />
            <TabPane tab="Approved" key={"approved"} />
            <TabPane tab="Completed" key={"completed"} />
            <TabPane tab="Cancelled" key={"cancelled"} />
          </Tabs>
        </PageHeader>
        <div className={"content_container"}>
          <PurchaseTable
            ref={tableRef}
            apiurl={API_URL}
            columns={filterCols()}
            mainSearch={mainSearch}
            resetTable={resetTable}
            selectedDestination={selectedDestination}
            datePickerValue={datePickerValue}
            ChangedSelected={(selected) => {
              itemSelected(selected);
            }}
            rowClick={(selected) => {
              rowIsSelected(selected);
            }}
            packageStatus={packageStatus}
          />
        </div>
      </div>
    </div>
  );
};

export default Index;
